<template>
  <div>
    <Card style="padding-bottom: 40px">
      <div>
        <Form :label-width="100">
          <Row>
            <Col :span="6">
              <FormItem label="值班人员">
                <Input v-model="historyFrom.dutyPersonnel" @on-blur="getHistoryRecordData" clearable
                       @on-clear="getHistoryRecordData('clean')"></Input>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="区县">
                <Select v-model="historyFrom.countyId" @on-change="getHistoryRecordData" clearable
                        @on-clear="getHistoryRecordData('clean')">
                  <Option v-for="(item,index) in countyList" :key="index" :value="item.indexCode" :label="item.name"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="开始时间">
                <DatePicker v-model="historyFrom.startTime" type="date" placeholder="选择开始日期"
                            @on-change="getHistoryRecordData" clearable
                            @on-clear="getHistoryRecordData('clean')"></DatePicker>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="结束时间">
                <DatePicker v-model="historyFrom.endTime" type="date" placeholder="选择开始日期"
                            @on-change="getHistoryRecordData" clearable
                            @on-clear="getHistoryRecordData('clean')"></DatePicker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <Table
        :loading="historyRecordLoading"
        :columns="historyRecordColumns"
        :data="historyRecordData"
        :border="true"
        :highlight-current-row="true"
      >
<!--        <template slot-scope="{ row }" slot="action">-->
<!--          <el-button type="text" size="mini" @click="goEdit(row)">修改</el-button>-->
<!--        </template>-->
      </Table>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            :total="historyRecordTotal"
            :page-size="historyRecordPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="historyRecordCurrentPage"
            @on-change="historyRecordPageChange"
            @on-page-size-change="historyRecordPageSizeChange"
      ></Page>
    </Card>
  </div>
</template>
<script>
import { columns } from '../js/columns'

export default {
  data() {
    return {
      historyRecordLoading: true,
      historyRecordTotal: 0,
      historyRecordColumns: columns,
      historyRecordData: [],
      historyRecordPageSize: 10,
      pageSizeOpts: [ 10, 20, 30, 40 ],
      historyRecordCurrentPage: 1,
      historyFrom: {
        startTime: null,
        endTime: null,
        dutyPersonnel: null,
        countyId: null
      },
      countyList: []
    }
  },
  mounted() {
    this.getHistoryRecordData()
    this.getCountyList()
  },
  methods: {
    // 获取区县列表
    getCountyList() {
      this.$http.get('/api/getLowerLevelDepts?flag=3').then(res => {
        this.countyList = res.data
      })
    },
    // 获取历史记录数据
    getHistoryRecordData(value) {
      this.historyRecordLoading = true
      if (value === 'clean') {
        this.historyFrom = {
          startTime: null,
          endTime: null,
          dutyPersonnel: null,
          countyId: null
        }
      }
      let requestData = {
        ...this.historyFrom,
        size: this.historyRecordPageSize,
        page: this.historyRecordCurrentPage
      }
      this.$http.post('/api/getRecordsList', requestData).then(res => {
        this.historyRecordData = res.data.data
        this.historyRecordTotal = res.data.recordsTotal
        this.historyRecordLoading = false
      })
    },
    goEdit(row) {
      let id = row.id
      this.$router.push({ name: 'WatchRecord', query: { recordId: id } })
    },
    historyRecordPageChange(page) {
      this.historyRecordCurrentPage = page
      this.getHistoryRecordData()
    },
    historyRecordPageSizeChange(pageSize) {
      this.historyRecordPageSize = pageSize
      this.getHistoryRecordData()
    }
  },
}
</script>
<style scoped>

</style>
